import { Icon } from 'components/ui/general';

import { reactSelectComponents } from '../reactSelectComponents';

export const MultiValueRemove = (props: any) => {
  const { selectProps }: { [key: string]: any } = props;
  const { iconMultiValueRemove } = selectProps;

  if (iconMultiValueRemove)
    return (
      <reactSelectComponents.MultiValueRemove {...props}>
        <Icon name={iconMultiValueRemove} font="ericeira" />
      </reactSelectComponents.MultiValueRemove>
    );

  return <reactSelectComponents.MultiValueRemove {...props} />;
};
